<template lang="pug">
    .wrapper
        .product-description
            h3.title {{ productName }}  -  {{ productPrice }}
        // pre {{ matrix }}
        table.table.is-bordered
            th.is-fixed-size.is-center color
            th.is-center.image-header
            th.is-center(v-for="size in matrix.sizes" v-if="isSizeVisible(size)") {{ size }}
            th.is-center.is-fixed-size.qty qty
            th.is-center.is-fixed-size sum
            tr(v-for="(row, i) in matrix.rows" v-if="row.qty")
                th.color-cell
                    span.label
                        nobr {{ row.label }}
                th.colorimage-cell(
                    v-if="row.image && row.image.cdn"
                    :style="{ backgroundImage: 'url(' + row.image.cdn + ')'}"
                )
                th.colorimage-cell(v-else)
                td.article.is-center(v-for="column in row.columns"  v-if="isSizeVisible(column.label)")
                    span(v-if="column.qty") {{ column.qty }}
                td.is-center.is-fixed-size.qty
                    span(v-if="row.qty") {{ row.qty }}
                td.is-center.is-fixed-size
                    span(v-if="row.sum") {{ row.sum | moneyFormat }}
            //- tr(v-for="color in colors")
            //-     td.color-cell.is-center.is-fixed-size
            //-         span.label
            //-             nobr {{ color }}
            //-     td(v-for="size in sizes")
            //-         Article(
            //-             :article="getArticle(color, size)"
            //-             :product="product"
            //-         )
            //-     td.is-center.is-fixed-size.qty(v-html="getColorQty(color)")
            //-     td.is-center.is-fixed-size(v-html="getColorPrice(color)")

</template>
<script>
// import Article from './Article'

import { get, round, cloneDeep, set, each, filter, orderBy, findIndex, find } from 'lodash'
import { mapGetters } from 'vuex'
import { moneyFormat, findPrice } from '@/filters'

export default {
    name: "Matrix",
    // components: {
    //     Article
    // },
    props: {
        product: {
            Type: Object,
            required: true
        }
    },
    computed: {
        tax() {
            return (100 + this.defaultTax.value) / 100
        },
        productName() {
            return this.product.nr + ' ' + this.product.name
        },
        productPrice() {
            // let price = 0

            // let code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'

            // let type = 'main'
            // let p

            // if (this.defaultCustomerGroup.id !== get(this.customer, 'customerGroup.id')) type = 'group'

            // if (! p) {
            //     const currentProductPrices = get(this.product, 'prices') || []
            //     if (type === 'main') p = currentProductPrices.find(el => el => el.type === type)
            //     else p = currentProductPrices.find(el => get(el, 'customerGroup.id') === get(el, 'customerGroup.id'))
            // }

            // if (p && p.value) {
            //     price = p.value / this.tax
            // }

            // return moneyFormat(price, code)

            const price = findPrice(this.product, this.customer, this.defaultCustomerGroup, true);
            const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'

            if (get(this.customer, 'show_net_prices')) {
                const taxRate = get(price, 'tax.value') || this.defaultTax.value;
                const tax = round((price.value * taxRate) / (100 + taxRate), 2);

                return moneyFormat((price.value - tax), code)
            } else {
                return moneyFormat(price.value, code)
            }
        },
        articles() {
            return get(this.product, 'articles') || []
        },
        matrix() {
            let matrix = {
                colors: this.colors,
                sizes: this.sizes,
                rows: [],
            }

            let articles = _.cloneDeep(this.articles)
            articles.forEach(article => {

                // get color

                const colorPropertyPivot = article.propertyPivots.find(el => {
                    return ['color', 'colour', 'farbe'].includes(el.property.key.toString().toLowerCase())
                })

                const colorValue = get(colorPropertyPivot, 'value')
                const colorField = get(colorPropertyPivot, 'property.propType.value_field')
                const colorAltField = get(colorPropertyPivot, 'property.propType.value_field_alt')

                const color = colorValue[colorAltField] || colorValue[colorField]
                // if (!matrix.colors.includes(color)) matrix.colors.push(color)
                article.color = color

                // get size

                const sizePropertyPivot = article.propertyPivots.find(el => {
                    return ['size', 'größe'].includes(el.property.key.toString().toLowerCase())
                })

                const sizeValue = get(sizePropertyPivot, 'value')
                const field = get(sizePropertyPivot, 'property.propType.value_field')
                const altField = get(sizePropertyPivot, 'property.propType.value_field_alt')

                const size = sizeValue[altField] || sizeValue[field]
                // if (!matrix.sizes.includes(size)) matrix.sizes.push(size)
                article.size = size

                // // if there is no row with the current color label
                // // create a new one
                // if (! matrix.rows.find(el => el.label === color)) {
                //     matrix.rows.push({ label: color, columns: [] })
                // }
            })

            const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'

            matrix.colors.forEach(color => {
                let row = {
                    label: color.color,
                    columns: [],
                    image: this.getColorImage(color.image),
                    qty: 0,
                    sum: 0
                }
                matrix.sizes.forEach(size => {
                    let column = { label: size, qty: 0 }
                    const article = articles.find(el => el.color === color.color && el.size === size)
                    if (article) {
                        const item = this.cart.articles.find(el => el.id === article.id)
                        if (item && item.qty) {
                            column.qty = item.qty
                            row.qty += item.qty

                            const price =
                                findPrice(article, this.customer, this.defaultCustomerGroup, true) ||
                                findPrice(this.product, this.customer, this.defaultCustomerGroup, true);

                            if (get(this.customer, 'show_net_prices')) {
                                const taxRate = get(price, 'tax.value') || this.defaultTax.value;
                                const tax = round((price.value * taxRate) / (100 + taxRate), 2);
                                row.sum += ((price.value - tax) * item.qty)
                            } else {
                                row.sum += (price.value * item.qty)
                            }
                        }
                    }
                    row.columns.push(column)
                })
                matrix.rows.push(row)
            })

            return matrix
        },
        colors() {
            const colorPropertyPivot = this.product.propertyPivots.find(el => {
                return ['color', 'colour', 'farbe'].includes(el.property.key.toString().toLowerCase())
            })
            const colors = get(colorPropertyPivot, 'values')
            const field = get(colorPropertyPivot, 'property.propType.value_field')
            const altField = get(colorPropertyPivot, 'property.propType.value_field_alt')

            let values = []
            if (colors && field) {
                values = colors.map(el => {
                    return {color: el[altField] || el[field], image: el['image'] || undefined}
                })
            }

            return values

            // const items = cloneDeep(this.articles)
            // let colors = {}

            // each(items, item => {
            //     let colorProp = find(item.properties, prop => {
            //         const key = get(prop, 'key')
            //         if (key && ['color', 'colour', 'farbe'].includes(key.toString().toLowerCase())) {
            //             return prop
            //         }
            //     })
            //     if (colorProp) {
            //         let colorValue, colorLabel, colorImage  = undefined

            //         if (get(colorProp.pivot, 'text')) {
            //             colorLabel = get(colorProp.pivot, 'text')
            //         }
            //         if (get(colorProp.pivot, 'color')) {
            //             colorValue = get(colorProp.pivot, 'color')
            //         }
            //         if (get(colorProp.pivot, 'image')) {
            //             colorImage = get(colorProp.pivot, 'image')
            //         }
            //         let colorName = this.product.id + '-' + this.stringToHash(colorLabel)
            //         if (!colors[colorName] || !colors[colorName]['key'] || colors[colorName]['key'] != colorName) {
            //             set(colors, colorName, {
            //                 label: colorLabel, value: colorValue, image: colorImage, key: colorName
            //             })
            //         }
            //         if (!colors[colorName]['label'] && colorLabel) {
            //             set(colors, `${colorName}.label`, {
            //                 label: colorLabel
            //             })
            //         }
            //         if (!colors[colorName]['value'] && colorValue) {
            //             set(colors, `${colorName}.value`, {
            //                 value: colorValue
            //             })
            //         }
            //         if (!colors[colorName]['image'] && colorImage) {
            //             set(colors, `${colorName}.image`, {
            //                 image: colorImage
            //             })
            //         }
            //     }
            // })
            // return orderBy(colors, 'label')
        },
        sizes() {
            const sizePropertyPivot = this.product.propertyPivots.find(el => {
                return ['size', 'größe'].includes(el.property.key.toString().toLowerCase())
            })
            const sizes = get(sizePropertyPivot, 'values')
            const field = get(sizePropertyPivot, 'property.propType.value_field')
            const altField = get(sizePropertyPivot, 'property.propType.value_field_alt')

            let values = []
            if (sizes && field) {
                values = sizes.map(el => el[altField] || el[field])
            }

            return values

            // const items = cloneDeep(this.articles)
            // let sizeProperties = []
            // each(items, item => {
            //     let sizeProp = filter(item.properties, prop => {
            //         const key = get(prop, 'key')
            //         if (key && ['size', 'größe'].includes(key.toString().toLowerCase())) {
            //             return prop
            //         }
            //     })
            //     if (sizeProp) {
            //         each(sizeProp, prop => {
            //             let size = undefined
            //             let sizePropTypeValue = get(prop, 'propType.value_field')
            //             if (get(prop.pivot, sizePropTypeValue)) {
            //                 size = get(prop.pivot, sizePropTypeValue)
            //             } else {
            //                 let sizePropTypeAltValue = get(prop, 'propType.value_field_alt')
            //                 if (get(prop.pivot, sizePropTypeAltValue)) {
            //                     size = get(prop.pivot, sizePropTypeAltValue)
            //                 }
            //             }
            //             let sizeIndex = findIndex(sizeProperties, ['size', size])
            //             if (sizeIndex == -1) {
            //                 sizeProperties.push({id: prop.pivot.id, size })
            //             }
            //         })
            //     }
            // })

            // sizeProperties.forEach(prop => {
            //     const size = get(prop, 'size')
            //     if (size) {
            //         switch (size.toString().toLowerCase()) {
            //             case 'os':
            //                 prop.position = 0
            //                 break;
            //             case 'xs':
            //                 prop.position = 1
            //                 break;
            //             case 's':
            //                 prop.position = 2
            //                 break;
            //             case 'm':
            //                 prop.position = 3
            //                 break;
            //             case 'l':
            //                 prop.position = 4
            //                 break;
            //             case 'xl':
            //                 prop.position = 5
            //                 break;
            //         }
            //     }
            // })
            // return orderBy(sizeProperties, ['position', 'size'], 'asc')
        },
        // sortedArticles() {
        //     const items = cloneDeep(this.articles)
        //     let sortedData = {}
        //     each(items, item => {
        //         let colorName = undefined
        //         let colorProp = find(item.properties, prop => {
        //             const key = get(prop, 'key')
        //             if (key && ['color', 'colour', 'farbe'].includes(key.toString().toLowerCase())) {
        //                 return prop
        //             }
        //         })
        //         if (colorProp) {
        //             let colorLabel
        //             // let colorPropTypeValue = get(colorProp, 'propType.value_field')
        //             if (get(colorProp.pivot, 'text')) {
        //                 colorLabel = get(colorProp.pivot, 'text')
        //             }
        //             // if (get(colorProp.pivot, 'color')) {
        //             //     colorValue = get(colorProp.pivot, 'color')
        //             // }
        //             // if (get(colorProp.pivot, 'image')) {
        //             //     colorImage = get(colorProp.pivot, 'image')
        //             // }
        //             // if (get(colorProp.pivot, 'number')) {
        //             //     colorNumber = get(colorProp.pivot, 'number')
        //             // }
        //             colorName = this.product.id + '-' + this.stringToHash(colorLabel)
        //             if (!sortedData[colorName]) {
        //                 sortedData[colorName] = {}
        //             }
        //             let sizeProp = find(item.properties, prop => {
        //                 const key = get(prop, 'key')
        //                 if (key && ['size', 'größe'].includes(key.toString().toLowerCase())) {
        //                     return prop
        //                 }
        //             })
        //             if (sizeProp) {
        //                 let sizePropTypeValue = get(sizeProp, 'propType.value_field')
        //                 let size = get(sizeProp.pivot, sizePropTypeValue)
        //                 if (!size) {
        //                     let sizePropTypeAltValue = get(sizeProp, 'propType.value_field_alt')
        //                     if (get(sizeProp.pivot, sizePropTypeAltValue)) {
        //                         size = get(sizeProp.pivot, sizePropTypeAltValue)
        //                     }
        //                 }
        //                 if (size) {
        //                     if (!sortedData[colorName][size])
        //                     set(sortedData, `${colorName}.${size}`, { article: item })
        //                 }
        //             }
        //         }
        //     })
        //     return sortedData
        // },
        ...mapGetters({
            cart: 'shop/cart',
            customer: 'shop/customer',
            defaultCustomerGroup: 'defaultCustomerGroup',
            defaultTax: 'defaultTax',
        }),
    },
    methods: {
        getColorImage(image){
            if(!image) return undefined
            let width = image.width
            let height = image.height

            const aspectRatio = width / height
            const maxHeight = 200

            if (height > maxHeight) {
                height = maxHeight
                width = height * aspectRatio
            }

            let root = '';
            const endpoint = process.env.VUE_APP_API_ENDPOINT
            if ( process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE ) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE
            const base =  endpoint + root + 'images/'

            return {
                cdn: image.source.url,
                src: `${base}${image.id}/${image.source.name}?fit&h=${height}&format=webp`,
                error: `${base}${image.id}/${image.source.name}?fit&h=${height}&preview=greyscale`,
                loading: `${base}${image.id}/${image.source.name}?fit&h=${height}&preview=blur`,
                width,
                height,
                aspectRatio
            }
        },
        isSizeVisible(size) {
            return !! this.matrix.rows.find(row => {
                return !! row.columns.find(column => column.label === size && column.qty > 0)
            })
        }
        // getArticle(color, size) {
        //     let articleSize, articleColor
        //     let articles = cloneDeep(this.sortedArticles)
        //     articleColor = articles[color.key]
        //     if (articleColor) {
        //         articleSize = articleColor[size.size]
        //         if (articleSize) {
        //             return articleSize.article
        //         }
        //     }
        //     return false
        // },
        // getColorQty(color) {
        //     let sizes = get(this.sortedArticles, color.key)
        //     let totalQty = 0
        //     each(sizes, size => {
        //         let articleQty = get(size, 'article.qty')
        //         totalQty = totalQty + articleQty
        //     })
        //     return totalQty
        // },
        // getColorPrice(color) {

        //     let sizes = get(this.sortedArticles, color.key)
        //     // let customer = cloneDeep(this.customer)
        //     let totalPrice = 0
        //     // let product = cloneDeep(this.product)
        //     let code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'

        //     each(sizes, size => {
        //         const articlePrice =
        //             findPrice(get(size, 'article'), this.customer, this.defaultCustomerGroup, true) ||
        //             findPrice(this.product, this.customer, this.defaultCustomerGroup, true);
        //         const taxRate = get(articlePrice, 'tax.value') || this.defaultTax.value;
        //         const tax = round((articlePrice.value * taxRate) / (100 + taxRate), 2);
        //         totalPrice = totalPrice + ((articlePrice.value - tax) * get(size, 'article.qty', 0))
        //     })
        //     return moneyFormat(totalPrice, code)
        // },
        // stringToHash(string) {
        //     if (! string) return undefined
        //     string = string.toString()

        //     var hash = 0
        //     if (string && string.length == 0) return hash

        //     for (let i = 0; i < string.length; i++) {
        //         let char = string.charCodeAt(i);
        //         hash = ((hash << 5) - hash) + char
        //         hash = hash & hash
        //     }

        //     return hash;
        // },
    }
}
</script>
<style lang="sass" scoped>
    .wrapper
        margin-bottom: 50px
        h3.title
            font-size: 24px
            margin-bottom: 10px
        table
            width: 100%
            .is-center
                text-align: center
            td
                vertical-align: baseline
            th
                background-color: #fafafa
            .is-fixed-size
                width: 125px
                font-weight: bold
            .is-fixed-size.qty
                width: 75px
    .colorimage-cell
        padding: 0!important
        height: 45px
        width: 45px
        text-align: center
        background-position: center
        background-size: cover
        background-repeat: no-repeat
    .image-header
        padding: 0!important
</style>
